import TabLayout from './crowdfunding_tab_layout'
import { connect } from 'react-redux'
import { publicContributionsListSelector } from 'redux/selectors/contributions'

const mapStateToProps = (state, ownProps) => {
  return {
    contributions: publicContributionsListSelector(state, ownProps),
    ...ownProps,
  }
}

export default connect(mapStateToProps)(TabLayout)
